webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Food__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Fitness__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Overview__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Navigation__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    Fitness: __WEBPACK_IMPORTED_MODULE_1__components_Fitness__["a" /* default */],
    Food: __WEBPACK_IMPORTED_MODULE_0__components_Food__["a" /* default */],
    Navigation: __WEBPACK_IMPORTED_MODULE_3__components_Navigation__["a" /* default */],
    Overview: __WEBPACK_IMPORTED_MODULE_2__components_Overview__["a" /* default */]
  },

  data: function data() {
    return {
      fitness: {
        pushups: 0,
        situps: 0,
        squats: 0,
        calfRaises: 0
      },
      food: { log: '' },
      page: 'overview'
    };
  },


  methods: {
    changePage: function changePage(page) {
      this.page = page;
    }
  },

  mounted: function mounted() {
    // Check for existing food log.
    if (localStorage.getItem('healthTrackerFoodLog')) {
      this.food.log = localStorage.getItem('healthTrackerFoodLog');
    }

    // Check for existing fitness entries.
    if (localStorage.getItem('healthTrackerFitness')) {
      this.fitness = JSON.parse(localStorage.getItem('healthTrackerFitness'));
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'food',

  props: ['food'],

  methods: {
    storeFoodLog: function storeFoodLog() {
      // Save the food log in local storage.
      localStorage.healthTrackerFoodLog = this.food.log;
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fitness',
  props: ['fitness'],
  methods: {
    storeFitness: function storeFitness() {
      localStorage.healthTrackerFitness = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.fitness);
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'overview',
  props: ['food', 'fitness'],
  methods: {
    // Sends back a class if there are numbers in there.
    fitnessStatus: function fitnessStatus(exercise) {
      if (this.fitness[exercise] > 0) {
        return 'active';
      }
    }
  },
  data: function data() {
    return {
      status: ''
    };
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigation',
  props: ['page'],
  methods: {
    changePage: function changePage(page) {
      this.$emit('change-page', page);
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(12);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a952272_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(29);
function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a952272_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Food_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4386727b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Food_vue__ = __webpack_require__(16);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Food_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4386727b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Food_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fieldset',[_c('label',{attrs:{"for":"foodEntry"}},[_vm._v("Food Log")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.food.log),expression:"food.log"}],attrs:{"rows":"10","name":"foodEntry","id":"foodEntry"},domProps:{"value":(_vm.food.log)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.food, "log", $event.target.value)}}})]),_vm._v(" "),_c('fieldset',[_c('button',{on:{"click":_vm.storeFoodLog}},[_vm._v("Save")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fitness_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_657f4a16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fitness_vue__ = __webpack_require__(22);
function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-657f4a16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fitness_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_657f4a16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fitness_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"form-fields"},[_c('fieldset',{staticClass:"form-wrapper"},[_c('label',{attrs:{"for":"pushups"}},[_vm._v("Push-ups")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fitness.pushups),expression:"fitness.pushups"}],staticClass:"number-field",attrs:{"type":"number","name":"pushups","id":"pushups","step":"10","min":"0"},domProps:{"value":(_vm.fitness.pushups)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fitness, "pushups", $event.target.value)}}})]),_vm._v(" "),_c('fieldset',{staticClass:"form-wrapper"},[_c('label',{attrs:{"for":"situps"}},[_vm._v("Sit-ups")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fitness.situps),expression:"fitness.situps"}],staticClass:"number-field",attrs:{"type":"number","name":"situps","id":"situps","step":"10"},domProps:{"value":(_vm.fitness.situps)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fitness, "situps", $event.target.value)}}})]),_vm._v(" "),_c('fieldset',{staticClass:"form-wrapper"},[_c('label',{attrs:{"for":"squats"}},[_vm._v("Squats")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fitness.squats),expression:"fitness.squats"}],staticClass:"number-field",attrs:{"type":"number","name":"squats","id":"squats","step":"10"},domProps:{"value":(_vm.fitness.squats)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fitness, "squats", $event.target.value)}}})]),_vm._v(" "),_c('fieldset',{staticClass:"form-wrapper"},[_c('label',{attrs:{"for":"calfRaises"}},[_vm._v("Calf Raises")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fitness.calfRaises),expression:"fitness.calfRaises"}],staticClass:"number-field",attrs:{"type":"number","name":"calfRaises","id":"calfRaises","step":"10"},domProps:{"value":(_vm.fitness.calfRaises)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fitness, "calfRaises", $event.target.value)}}})]),_vm._v(" "),_c('fieldset',[_c('button',{staticClass:"save-button",on:{"click":_vm.storeFitness}},[_vm._v("Save")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6dfaadc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__(25);
function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d6dfaadc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6dfaadc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fitness-wrapper"},[_c('div',{staticClass:"fitness-item"},[_c('span',[_vm._v("Pushups")]),_vm._v(" "),_c('div',{staticClass:"fitness-number",class:_vm.fitnessStatus('pushups')},[_vm._v(_vm._s(_vm.fitness.pushups))])]),_vm._v(" "),_c('div',{staticClass:"fitness-item"},[_c('span',[_vm._v("Situps")]),_vm._v(" "),_c('div',{staticClass:"fitness-number",class:_vm.fitnessStatus('situps')},[_vm._v(_vm._s(_vm.fitness.situps))])]),_vm._v(" "),_c('div',{staticClass:"fitness-item"},[_c('span',[_vm._v("Squats")]),_vm._v(" "),_c('div',{staticClass:"fitness-number",class:_vm.fitnessStatus('squats')},[_vm._v(_vm._s(_vm.fitness.squats))])]),_vm._v(" "),_c('div',{staticClass:"fitness-item"},[_c('span',[_vm._v("Calf Raises")]),_vm._v(" "),_c('div',{staticClass:"fitness-number",class:_vm.fitnessStatus('calfRaises')},[_vm._v(_vm._s(_vm.fitness.calfRaises))])])]),_vm._v(" "),(_vm.food.log)?_c('div',{staticClass:"food-wrapper"},[_c('div',{staticClass:"food-label"},[_vm._v("Food Log")]),_vm._v(" "),_c('div',{staticClass:"food-log"},[_vm._v(_vm._s(_vm.food.log))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac7b0822_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(28);
function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac7b0822"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac7b0822_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"header-heading"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.changePage('overview')}}},[_vm._v("100 Days of Health")])]),_vm._v(" "),_c('div',{staticClass:"options"},[_c('button',{staticClass:"option icon-bicycle",on:{"click":function($event){_vm.changePage('fitness')}}}),_vm._v(" "),_c('button',{staticClass:"option icon-food",on:{"click":function($event){_vm.changePage('food')}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navigation',{attrs:{"page":_vm.page},on:{"change-page":_vm.changePage}}),_vm._v(" "),_c('div',{staticClass:"app-wrapper"},[(_vm.page === 'overview')?_c('Overview',{attrs:{"fitness":_vm.fitness,"food":_vm.food}}):_vm._e(),_vm._v(" "),(_vm.page === 'fitness')?_c('Fitness',{attrs:{"fitness":_vm.fitness}}):_vm._e(),_vm._v(" "),(_vm.page === 'food')?_c('Food',{attrs:{"food":_vm.food}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[7]);


// WEBPACK FOOTER //
// static/js/app.8a6615e89cd6120c061a.js